module.exports = __webpack_public_path__ + "img/flip-3.61483ed4.png";